<template>
  <div id="app">
    <router-view />
  </div>
</template>
<!-- <script>
import { checkAutoLogout } from './store/modules/auth'; // atau dari utils jika sudah dipindah

export default {
  mounted() {
    setInterval(() => {
      checkAutoLogout();
    }, 5000);
  }
};
</script> -->